import { BIModel } from './BIModel';

export class SellProfileStatusViewBIModel extends BIModel {
  static eventName = 'sell_profile_status_view';

  #statusName;

  constructor(userId, statusName) {
    super(SellProfileStatusViewBIModel.eventName, userId);
    this.#statusName = statusName;
  }

  get statusName() {
    return this.#statusName;
  }

  get modelData() {
    return {
      status_name: this.statusName
    };
  }

}